import { render, staticRenderFns } from "./SetupView.html?vue&type=template&id=1152ad66&scoped=true&"
import script from "./SetupView.js?vue&type=script&lang=js&"
export * from "./SetupView.js?vue&type=script&lang=js&"
import style0 from "./SetupView.scss?vue&type=style&index=0&id=1152ad66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152ad66",
  null
  
)

export default component.exports